<template>
<span>
    <svg v-if="type=='onsite'" width="20" height="20" xmlns="http://www.w3.org/2000/svg" class="mr-1" style="vertical-align:text-bottom;">
        <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Template-1-/-Course-Info" transform="translate(-50 -263)" fill="#383838">
        <g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)"><g id="mode">
        <g id="icon/popular/state/onsite">
        <path d="M12.5 5.5v.582l4.127 1.088a.5.5 0 01.373.484V9h4.484a.5.5 0 110 1H21v10.898c0 .035-.004.07-.01.102h.494a.5.5 0 110 1H2.5a.5.5 0 110-1h.51a.502.502 0 01-.01-.102V10h-.538C2.207 10 2 9.776 2 9.5s.207-.5.462-.5H7V7.654a.5.5 0 01.379-.485L11.5 6.14V2.5a.5.5 0 111 0H16a.5.5 0 01.5.5v2a.5.5 0 01-.5.5h-3.5zm0-1h3v-1h-3v1zM20.01 21a.502.502 0 01-.01-.102V10h-3v11h3.01zM3.99 21H7V10H4v10.898c0 .035-.004.07-.01.102zM10 21v-5.5c0-.276.18-.5.4-.5h3.2c.22 0 .4.224.4.5V21h2V8.024L12.12 7 8 8.03V21h2zm1-5v5h2v-5h-2zm-.5-6a.5.5 0 110-1h3.106a.5.5 0 110 1H10.5z" id="Combined-Shape"/>
        </g></g></g></g></g></g>
    </svg>
   
    <svg v-if="type=='online'" width="20" height="20" xmlns="http://www.w3.org/2000/svg" class="mr-1" style="vertical-align:text-bottom;">
        <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Template-1-/-Course-Info" transform="translate(-82 -287)" fill="#383838">
        <g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)">
        <g id="mode"><g id="icon/popular/state/online" transform="translate(32 24)">
        <path d="M9.5 18v-2h-6A1.5 1.5 0 012 14.5v-11A1.5 1.5 0 013.5 2h17A1.5 1.5 0 0122 3.5v11a1.5 1.5 0 01-1.5 1.5h-6v2h.5a2.5 2.5 0 012.5 2.5v1a.5.5 0 01-.5.5H7a.5.5 0 01-.5-.5v-1A2.5 2.5 0 019 18h.5zm0 1H9a1.5 1.5 0 00-1.5 1.5v.5h9v-.5A1.5 1.5 0 0015 19H9.5zm1-1h3v-2h-3v2zm4-3h6a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-17a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h11zm-2.867-2.286c-.673-.623-2.115-.818-4.322-.51a.5.5 0 01-.569-.495V5.933a.5.5 0 01.302-.46c1.866-.806 3.547-.581 4.956.664 1.41-1.245 3.09-1.47 4.956-.663a.5.5 0 01.302.459v5.776a.5.5 0 01-.57.495c-2.206-.308-3.648-.113-4.321.51a.503.503 0 01-.367.16.486.486 0 01-.367-.16zm.867-1.255c.898-.392 2.15-.49 3.758-.316V6.271c-1.452-.534-2.678-.282-3.758.765v4.423zm-1-4.423c-1.08-1.047-2.306-1.299-3.758-.765v4.872c1.608-.174 2.86-.076 3.758.316V7.036z" id="Combined-Shape"/>
        </g></g></g></g></g></g>
    </svg>
    
    <svg v-if="type=='blended'" width="21px" height="20px" xmlns="http://www.w3.org/2000/svg" class="mr-1" style="vertical-align:text-bottom;">
        <g id="Course-Templates" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Template-1-/-Course-Info" transform="translate(-50 -287)" fill="#383838">
        <g id="TOP-INFO" transform="translate(48 203)"><g id="sub-info" transform="translate(0 58)">
        <g id="mode"><g id="icon/popular/state/blended" transform="translate(0 24)">
        <path d="M4.008 4.048A.506.506 0 014.006 4V2.478a.5.5 0 01.663-.472l1.347.465 1.347-.465a.5.5 0 01.663.472V4H15.5a.5.5 0 01.5.5V9h3.5a1.5 1.5 0 011.5 1.5v4.563c1.23.316 2 1.79 2 3.437 0 1.861-.983 3.5-2.5 3.5S18 20.361 18 18.5c0-1.648.77-3.121 2-3.437V10.5a.5.5 0 00-.5-.5H16v10.5a.5.5 0 01-.5.5h-11a2.5 2.5 0 01-2.446-1.978l-.035-.01.02-.07A2.515 2.515 0 012 18.5v-12a2.5 2.5 0 012.008-2.452zM5.006 4h2.02v-.82l-.847.293a.5.5 0 01-.326 0l-.847-.293V4zM20 16.142c-.583.343-1 1.27-1 2.358 0 1.38.672 2.5 1.5 2.5s1.5-1.12 1.5-2.5c0-1.089-.417-2.015-1-2.358v1.006a.5.5 0 11-1 0v-1.006zM14 20v-2H4.661c-.796-.009-1.298.3-1.58.99A1.5 1.5 0 004.5 20H14zm1-1V5H4.5A1.5 1.5 0 003 6.5v10.985c.442-.327 1.003-.492 1.667-.485H15v2zM5 6h8a1 1 0 011 1v5a1 1 0 01-1 1H5a1 1 0 01-1-1V7a1 1 0 011-1zm0 1v5h8V7H5z" id="Combined-Shape"/>
        </g></g></g></g></g></g>
    </svg>
</span>
</template>

<script>
export default {
    name: "CourseTypeIcon",
    props: {
        color: {
            type:String,
            default() {
                return '#00AEEF';
            }
        },
        type: {
            type:String,
            default() {
                return 'onsite';
            }
        }
    }
}
</script>

<style scoped>

</style>
